export default "__VITE_ASSET__CvdCVVFx__"